<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="impuesto"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
          class="flex flex-col w-full"
          autocomplete="off"
        >
          <div class="flex-1">
            <div>

              <div class="w-full" 
                v-if="(role === 7 || role === 8 || role === 3) && (!isIssuingCreation)">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('clients.entity_name')}}</label>
                <div class="flex justify-between">
                  <el-form-item prop="idCliente" class="w-full">
                    <base-el-select class="w-full" :options="clientes" v-model="form.idCliente" clearable filterable
                      :loading="loadingClientes" :disabled="!isCreate" />
                  </el-form-item>
                  <base-button v-if="!isCreate" class="mb-1 ml-4" mode="primary" :text="$t('app.detail')"  @click.prevent.stop="goDetailClient" :loading="isGeneralLoading" type="button" />
                </div>
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('products.ItemDescription')}}</label>
                <el-form-item prop="ItemDescription">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.ItemDescription"
                    maxlength='2500'
                    type="textarea"
                    :rows="3"
                  />
                </el-form-item>
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('products.UnitPriceWithoutTax')}}</label>
                <el-form-item prop="UnitPriceWithoutTax">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.UnitPriceWithoutTax"
                    type="number"
                    maxlength="9"
                  />
                </el-form-item>
              </div>
            </div>

            <div class="lg:mb-2">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('products.UnitOfMeasure')}}</label>
              <el-form-item prop="UnitOfMeasure">
                <base-el-select class="w-full" :options="tiposUnidadesMedida" v-model="form.UnitOfMeasure" filterable clearable/>
              </el-form-item>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('products.ArticleCode')}}</label>
                <el-form-item prop="ArticleCode">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.ArticleCode"
                    maxlength='20'
                  />
                </el-form-item>
              </div>
            </div>
          </div>

          <div v-if="isIssuingCreation || isProductCreation">
            <div v-for="(impuesto, key) in form.impuestos" :key="key" class="mb-2 mt-2 flex flex-col items-center w-full relative">
              <base-button-icon
                v-if="form.impuestos.length > 1"
                @click="removeTax(key)"
                name="cross"
                mode="primary-phantom"
                class="-top-3 -right-3 absolute"
                custom="dark:border dark:border-darkblue-600"
              />
              <div class="w-full p-4 bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border">
                <div class="px-2 w-full lg:mb-0">
                  <label class="text-sm font-semibold text-secondary-600 block mb-2"><base-obligatory-icon/>{{ $t('impuestos.entity_name') }}</label>
                  <el-form-item :prop="'impuestos.'+ key + '.name'" :rules="generalRules.general">
                    <el-select class="w-full" 
                      clearable
                      filterable
                      allow-create
                      v-model="form.impuestos[key].name" 
                      :placeholder="$t('invoices.invoices_issuing.step4.create_tax')"
                      :loading="isGeneralLoading" >
                      <el-option
                        v-for="opt in taxesList"
                        :key="opt.idImpuesto"
                        :label="opt.Name"
                        :value="`${opt.Name}:${opt.idImpuesto}`">
                      </el-option>
                    </el-select> 
                  </el-form-item>
                </div>
                <div v-if="!isNewTax(key)" class="flex flex-col md:flex-row items-center gap-x-2">
                  <div class="px-2 w-full lg:mb-0">
                    <label class="text-sm font-semibold text-secondary-600 block mb-2"><base-obligatory-icon/>{{ $t('invoices.invoices_issuing.tipo_impuesto') }}</label>
                    <el-form-item :prop="'impuestos.'+ key + '.taxType'" :rules="isNewTax(key) ? rules :generalRules.general">
                      <base-el-select 
                        class="w-full" 
                        :options="tiposCodigoImpuesto" 
                        v-model="form.impuestos[key].taxType"
                        filterable 
                        clearable/>
                    </el-form-item>
                  </div>
                  <div class="px-2 w-full lg:mb-0">
                    <label class="text-sm font-semibold text-secondary-600 block mb-2"><base-obligatory-icon/>{{ $t('impuestos.TaxRate') }}</label>
                    <el-form-item :prop="'impuestos.'+ key + '.taxRate'" :rules="isNewTax(key) ? rules :generalRules.general">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.impuestos[key].taxRate"
                        type="number"
                        maxlength="9">
                        <template slot="append">%</template>
                      </el-input>
                    </el-form-item>
                  </div>
                </div>  
              </div>
            </div>
            <div v-if="false" class="flex flex-row items-center">
              <base-button-responsive
                v-if="!tooMuchTaxes"
                mode="primary-phantom"
                :text="$t('invoices.invoices_issuing.step4.add_tax')"
                icon="plus"
                @click="addTax()"
                :loading="isGeneralLoading"
              />
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="isCreate ? $t('app.cancel') : $t('app.back')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="isIssuingCreation ? $t('app.save_and_back') : $t('app.save') "
            icon="check"
            @click="submitForm('ruleForm')"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
    </template>
  </detail-layout>
</template>

<script>
import { i18n } from '@/i18n'
import { DoubleUpToEightDecimalType } from '@/utils/regex'

import DetailLayout from '@/components/layout/DetailLayout.vue'

import { getClients } from '@/services/clients/getClients'
import { getProducto } from '@/services/configurations/getProducto'
import { newProducto } from '@/services/configurations/newProducto'
import { updateProducto } from '@/services/configurations/updateProducto'
import { getImpuestosSimple } from '@/services/configurations/getImpuestosSimple'
import { createProductWithTaxes } from '@/services/configurations/createProductWithTaxes'

import { setTransitionAllowed } from '@/services/functions/modeAllowedTransitionHelper'

export default {
  /* eslint-disable camelcase */
  name: 'producto-detail',
  components: {
    DetailLayout,
  },
  data: function () {
    return {
      showGeneratePassword: false,
      searchView: false,
      activeName: 'es',
      localUserId: null,
      distribuidores: [],
      loadingDistribuidores: false,
      loadingClientes: false,
      header: {
        title: i18n.t('products.header_long'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'masters/products',
        params: { issuingCreation: false }
      },
      loadedFirstTime: false,
      form: this.getDefaultForm(),
      clientes: [],
      taxesList: [],
      numMaxTaxes: 5,
      rules: {
        idCliente: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        ItemDescription: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        UnitOfMeasure: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        UnitPriceWithoutTax: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          // { required: true, validator: this.isValidPrice, trigger: 'blur' }
        ],
      },
      generalRules: {
        general: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          }
        ],
        taxRate: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
          { validator: this.isTaxRateValid, trigger: ['blur', 'change'] }
        ],
      }
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    isIssuingCreation: function () {
      return !!this.$store.getters['app/isInMode'](1)
    },
    isProductCreation: function () {
      return !!this.$store.getters['app/isInMode'](5)
    },
    issuingType: function () {
      return this.$store.getters['invoicesIssuing/issuingType']
    },
    id: function () {
      return this.$route.params.id
    },
    getIdClientLogged: function () {
      return this.$store.getters['auth/user'].idCliente
    },
    isClientFilterActive () {
      return this.$store.getters['products/isClientFilterActive']
    },
    actualFilterNav () {
      return this.$store.getters['app/idClienteFilterVNav']
    },
    isCreate: function () {
      return this.id === -1 || this.id === '-1'
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    tooMuchTaxes: function () {
      return this.form.impuestos.length >= this.numMaxTaxes
    },
    tiposUnidadesMedida: function () {
      return this.$store.getters['config/TIPOS_UNIDADES_MEDIDA']
    },
    tiposCodigoImpuesto: function () {
      // Excluimos el IRPF
      return this.$store.getters['config/TIPOS_CODIGO_IMPUESTO'].filter(element => element.id !== '04')
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    'form.idCliente': async function (value, oldValue) {
      if (value!==oldValue) {
        if (!value) this.taxesList = []
        else {
          this.taxesList = await this.getTaxesByClient(this.form.idCliente)
        }
      }
    }
  },
  async mounted () {
    if (this.isIssuingCreation) this.form.idCliente = this.$route.params.idCliente
    else if (this.isProductCreation) this.form.idCliente = this.getIdClientLogged
    this.taxesList = await this.getTaxesByClient(this.form.idCliente)
  },
  created: async function () {
    if (this.isCreate && !this.isIssuingCreation) await this.$store.dispatch('app/enterMode', 5)

    if (this.role === 7 || this.role === 8 || this.role === 3) {
      this.loadingClientes = true
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataClients))
      }
      this.clientes = dataClients.Clientes.map(x => ({ label: x.Nombre, key: x.idCliente, value: x.idCliente }))
      this.loadingClientes = false
    }
    
    const breadcrumbs = []
    if (this.isIssuingCreation) {
      this.header.url = 'invoicesissuing'
      this.header.params.issuingCreation = true
      this.header.params.issuingType = this.issuingType
      const issuingBreadcrumb = {
        path: 'invoicesissuing',
        name: i18n.t('invoices.invoices_issuing.header_long'),
        params: { issuingCreation: true, issuingType: this.issuingType }
      }
      if (this.issuingType === 2) issuingBreadcrumb.name = i18n.t('invoices.invoices_issuing.proforma.header_long')
      else if (this.issuingType === 3) issuingBreadcrumb.name = i18n.t('invoices.invoices_issuing.quotation.header_long')
      breadcrumbs.push(issuingBreadcrumb)
    } else {
      breadcrumbs.push({
        path: 'masters',
        name: i18n.t('masters.header')
      })
      breadcrumbs.push({ path: 'masters/products', name: i18n.t('products.header') })
    }

    if (!this.isCreate) {
      await this.downloadData(this.id)
      const truncName = this.truncate(this.form.ItemDescription, 30, false)
      breadcrumbs.push({ path: '', name: truncName })
      this.$store.commit('app/setheaderBreadCrumb', truncName)
    } else {
      breadcrumbs.push({
        path: '',
        name: i18n.t('products.new')
      })
      if (this.actualFilterNav && this.isClientFilterActive && !this.form.idCliente) {
        this.form.idCliente = this.actualFilterNav.idCliente 
      }
    }
    this.header.breadcrumb = breadcrumbs
  },
  methods: {
    getDefaultForm: function () {
      return {
        id: 0,
        ItemDescription: '',
        UnitOfMeasure: '01',
        UnitPriceWithoutTax: '',
        ArticleCode: '',
        idCliente: '',
        impuestos: [
          {
            idImpuesto: -1,
            name: '',
            taxType: '',
            taxRate: ''
          }
        ]
      }
    },
    isTaxRateValid: function (rule, value, callback) {
      if (!value) {
        return callback(new Error(i18n.t('validation.complete')))
      }
      const valueFloat = parseFloat(value)
      if (valueFloat < 0 || valueFloat > 100 || !DoubleUpToEightDecimalType.test(valueFloat)) {
        callback(new Error(i18n.t('validation.taxrate')))
      } else {
        callback()
      }
    },
    getTaxesByClient: async function (clientId) {
      const params = { 
        idCliente: clientId,
        taxType: '04' // excluimos el IRPF
      }
      const response = await getImpuestosSimple(params)
      if (response.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
      } else {
        return response.Respuesta
      }
    },
    goDetailClient () {
      const id = this.form.idCliente
      this.$router.push({ name: 'configurations/clients/details', params: { id } })
    },
    watchFormHandler: function ({
      certificate,
      send_alerts
    }) {},
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    isValidPrice: function (rule, value, callback) {
      // if (!value) {
      //   callback() // queremos que la validación sea opcional en este caso.
      // } else 
      if (!this.isValidPriceHandler(value)) {
        callback(new Error(i18n.t('validation.price_max_custom')))
      } else {
        callback()
      }
    },
    isValidPriceHandler (value) {
      const float = parseFloat(value)
      if (float > 0 && float <= 100) {
        return true
      }
      return false
    },
    submitForm: function (formName) {
      if (this.isCreate) {
        (this.isIssuingCreation || this.isProductCreation) ? this.newProductoEmisionHandler(formName) : this.newProductoHandler(formName)
      } else {
        this.updateProductoHandler(formName)
      }
    },
    isNewTax: function (key) {
      const idImpuesto = parseInt(this.form.impuestos[key].name.split(':')[1])
      const tax = this.taxesList.some(x => x.idImpuesto === idImpuesto)
      if (tax && this.form.impuestos[key].name !== '') {
        this.form.impuestos[key].idImpuesto = idImpuesto
        return true
      }
    },
    addTax () {
      if (this.form.impuestos.length >= this.numMaxTaxes) {
        this.doFeedback(i18n.t('invoices.invoices_issuing.step4.max_taxes', { maxTaxes: this.numMaxTaxes }), 'warning')
        return
      }
      const newTax = {
        idImpuesto: -1,
        name: '',
        taxType: '',
        taxRate: '',
      }
      this.form.impuestos.push(newTax)
    },
    removeTax (index) {
      if (this.form.impuestos) this.form.impuestos.splice((index), 1)
    },
    newProductoHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const params = {
            ItemDescription: this.form.ItemDescription,
            UnitOfMeasure: this.form.UnitOfMeasure,
            UnitPriceWithoutTax: this.form.UnitPriceWithoutTax,
            ArticleCode: this.form.ArticleCode,
            idCliente: this.form.idCliente,
          }
          const response = await newProducto(params)
          if (response.blnError === true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          } else {
            this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
            this.resetForm()
            this.form = this.getDefaultForm()
            this.goBack()
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    newProductoEmisionHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        } else {
          const params = {
            idProducto: -1,
            idCliente: this.form.idCliente,
            ItemDescription: this.form.ItemDescription,
            UnitOfMeasure: this.form.UnitOfMeasure,
            UnitPriceWithoutTax: this.form.UnitPriceWithoutTax,
            ArticleCode: this.form.ArticleCode,
            Impuestos: this.form.impuestos
          }
          const response = await createProductWithTaxes(params)
          if (response.blnError === true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          } else {
            this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
            this.resetForm()
            this.form = this.getDefaultForm()
            if (this.isIssuingCreation) this.goEmission()
            else if (this.isProductCreation) { 
              this.$store.dispatch('app/exitMode', 5)
              this.goBack()
            }
          }
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    updateProductoHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const params = {
            idProducto: this.form.id,
            ItemDescription: this.form.ItemDescription,
            UnitOfMeasure: this.form.UnitOfMeasure,
            UnitPriceWithoutTax: this.form.UnitPriceWithoutTax,
            ArticleCode: this.form.ArticleCode,
          }
          const response = await updateProducto(params)
          if (response.blnError === false) {
            this.$message({
              type: 'success',
              message: i18n.t('feedback.success.saved_data_msg')
            })
            this.updateView()
          } else {
            this.$message({
              type: 'error',
              message: response.msgError
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: i18n.t('feedback.error.process_data_error')
          })
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    goBack: function () {
      if (!this.isIssuingCreation) {
        this.$router.push({ name: 'masters/products' })
      } else {
        this.goEmission()
      }
    },
    downloadData: async function (id) {
      let res = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idProducto: id
        }
        res = await getProducto(params)
        this.setRes(res.Respuesta)
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return res
    },
    setRes: function (res) {
      this.form.ItemDescription = res.ItemDescription
      this.form.UnitOfMeasure = res.UnitOfMeasure
      this.form.UnitPriceWithoutTax = res.UnitPriceWithoutTax
      this.form.ArticleCode = res.ArticleCode
      this.form.id = res.idProducto
      this.form.idCliente = res.idCliente
    },
    updateView: function () {
      const truncName = this.truncate(this.form.ItemDescription, 30, false)
      this.header.breadcrumb[2].name = truncName
      this.$store.commit('app/setheaderBreadCrumb', truncName)
    },
    goEmission () {
      setTransitionAllowed(1, true)
      this.$router.push({ 
        name: 'invoicesissuing',
        params: { issuingCreation: true, issuingType: this.issuingType }
      })
    },
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style lang="sass" scoped>
</style>
